module.exports = __webpack_public_path__ + "img/rumiancev.cfadb3a8.jpg";